import { struct, bool, publicKey, u64, vec, array, u8, } from "@project-serum/borsh";
export const BurnLogLayout = struct([
    // amount's type is `spl_math::uint::U256`, which borsh doesn't support.
    u64("amount_section_1"),
    u64("amount_section_2"),
    u64("amount_section_3"),
    u64("amount_section_4"),
    u8("recipient_len"),
    array(u8(), 32, "recipient"),
]);
export const MintLogLayout = struct([bool("is_initialized")]);
export const RenVmMsgLayout = struct([
    array(u8(), 32, "p_hash"),
    array(u8(), 32, "amount"),
    array(u8(), 32, "token"),
    array(u8(), 32, "to"),
    array(u8(), 32, "n_hash"),
]);
export const GatewayLayout = struct([
    bool("is_initialized"),
    array(u8(), 20, "renvm_authority"),
    array(u8(), 32, "selectors"),
    u64("burn_count"),
    u8("underlying_decimals"),
]);
export const GatewayStateKey = "GatewayStateV0.1.4";
export const GatewayRegistryLayout = struct([
    bool("is_initialized"),
    publicKey("owner"),
    u64("count"),
    vec(array(u8(), 32), "selectors"),
    vec(publicKey(), "gateways"),
]);
export const GatewayRegistryStateKey = "GatewayRegistryState";
//# sourceMappingURL=layouts.js.map